import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    voucher_applications_subtitle: 'Заявления на ваучер',
    voucher_applications_errorLoad: 'Ошибка при загрузке данных',
    voucher_applications_queuedNumber: '№ очереди',
    voucher_applications_requestFormId: '№ Заявления',
    voucher_applications_childIin: 'ИИН ребенка',
    voucher_applications_childFIO: 'ФИО ребенка',
    voucher_applications_childBirthday: 'Дата рождения',
    voucher_applications_queuedType: 'Тип очереди',
    voucher_applications_status: 'Статус заявки',
    voucher_applications_priorityCategory: 'Категория очередности',
    voucher_applications_queuedRegion: 'Регион',
    voucher_applications_actionsRevoke: 'Отозвать заявление из очереди',
    voucher_applications_actionsDownload: 'Скачать заявление',
    voucher_applications_actionsGetVoucher: 'Принять ваучер',
    voucher_applications_actionsConfirmInterested: 'Подтвердить заинтересованность',
    voucher_applications_actionsInterested: 'Заинтересован',
    voucher_application_submissionDate: 'Дата создания',
    voucher_application_acceptVoucherDeadline: 'Срок ваучера',

    //modal
    voucher_applications_modalBodyInterested: 'Подтвердите свое действие',
    voucher_applications_modalTitleInterested:
      'Подтверждение заинтересованности в получении ваучера',
    voucher_applications_modalTitleRevoke: 'Отозвать заявление из очереди',
    voucher_applications_modalBodyRevoke:
      'Вы действительно хотите отозвать заявление из очереди? При отзыве, полученное заявление аннулируется и будет отправлено в архив',
    voucher_applications_modalYes: 'Да',
    voucher_applications_modalNo: 'Нет',
    voucher_applications_actionsRejectVoucher: 'Отклонить ваучер',
    voucher_applications_modalTitleRejectVoucher: 'Отклонение ваучера',
    voucher_applications_modalTitleApproveVoucher: 'Принятие ваучера',
    voucher_applications_modalBodyApproveVoucher:
      'Вы действительно хотите принять ваучер в дошкольную организацию {{name}}, группа {{group_name}}, адрес {{address}}',
    voucher_applications_modalBodyRejectVoucher:
      'Если вы отклоните ваучер, ваше заявление и сам ваучер будут аннулированы, и вам потребуется подать новое заявление при необходимости.',

    //error
    voucher_applications_error_approve_applicant: 'Не удалось принять ваучер',
    voucher_applications_error_reject_applicant: 'Не удалось отклонить ваучер',
    voucher_applications_error_revoke_applicant: 'Не удалось отозвать ваучер',
    voucher_applications_check_bulletin_empty: 'В данный момент нет свободных бюллетень',
    voucher_applications_check_bulletin_error: 'Не удалось проверить бюллетени',
    voucher_applications_error_confirm_interest: 'Не удалось выполнить запрос'
  },
  kk: {
    voucher_applications_subtitle: 'Ваучерге өтініштер',
    voucher_applications_errorLoad: 'Деректерді жүктеуде қателік орын алды',
    voucher_applications_queuedNumber: 'Кезек №',
    voucher_applications_requestFormId: 'Өтініш №',
    voucher_applications_childIin: 'Баланың ЖСН-і',
    voucher_applications_childFIO: 'Баланың аты-жөні',
    voucher_applications_childBirthday: 'Туған күні',
    voucher_applications_queuedType: 'Кезек түрі',
    voucher_applications_status: 'Өтініш мәртебесі',
    voucher_applications_priorityCategory: 'Кезектілік санаты',
    voucher_applications_queuedRegion: 'Аймақ',
    voucher_applications_actionsRevoke: 'Өтінішті кезектен алу',
    voucher_applications_actionsDownload: ' Өтінішті жүктеп алу',
    voucher_applications_actionsGetVoucher: 'Ваучерді растау',
    voucher_applications_actionsConfirmInterested: 'Қызығушылықты растау',
    voucher_applications_actionsInterested: 'Мүдделікті растау',
    voucher_application_submissionDate: 'Жасалған күні',
    voucher_application_acceptVoucherDeadline: 'Ваучердің қолдану мерзімі',

    //modal
    voucher_applications_modalBodyInterested: 'Әрекетіңізді растаңыз',
    voucher_applications_modalTitleInterested: 'Ваучерді алуға қызығушылықты растау',
    voucher_applications_modalTitleRevoke: 'Өтінішті кезектен алу',
    voucher_applications_modalBodyRevoke:
      'Сіз өтінішіңізді кезектен қайтарып алғыңыз келетініне сенімдісіз бе? Қайтарылғаннан кейін қабылданған өтініштің күші жойылады және мұрағатқа жіберіледі',
    voucher_applications_modalYes: 'Иә',
    voucher_applications_modalNo: 'Жоқ',
    voucher_applications_actionsRejectVoucher: 'Ваучерден бас тарту',
    voucher_applications_modalTitleRejectVoucher: 'Ваучерден бас тарту',
    voucher_applications_modalTitleApproveVoucher: 'Ваучерді растау',
    voucher_applications_modalBodyApproveVoucher:
      'Сіз {{name}} мектепке дейінгі ұйымына, {{group_name}} тобына, {{address}} мекенжайы бойынша ваучерді қабылдауды растайсыз ба?',
    voucher_applications_modalBodyRejectVoucher:
      'Егер ваучерден бас тартсаңыз, сіздің өтінішіңіз бен ваучердің өзі жойылады, және қажет болған жағдайда жаңа өтініш беруіңіз керек.',

    //error
    voucher_applications_error_approve_applicant: 'Ваучерді қабылдау мүмкін болмады',
    voucher_applications_error_reject_applicant: 'Ваучерден бас тарту мүмкін болмады',
    voucher_applications_error_revoke_applicant: 'Ваучерді қайтарып алу мүмкін болмады',
    voucher_applications_check_bulletin_empty: 'Қазіргі уақытта бос бюллетеньдер жоқ',
    voucher_applications_check_bulletin_error: 'Бюллетеньдерді тексеру мүмкін болмады',
    voucher_applications_error_confirm_interest: 'Сұранысты орындау мүмкін болмады'
  }
});
